import { useEffect } from 'react';
import './SucessoAgendamento.css';

const SucessoAgendamento = ({ bookingDetails, onBackToHome }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!bookingDetails) return null;

    return (
        <div className="booking-success-overlay">
            <div className="booking-success-card">
                <div className="success-icon-wrapper">
                    <div className="success-checkmark">
                        <svg viewBox="0 0 52 52">
                            <circle className="success-circle" cx="26" cy="26" r="25" fill="none" />
                            <path className="success-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                </div>

                <h2 className="success-title">Agendamento Realizado!</h2>
                <p className="success-subtitle">Sua reserva foi concluída com sucesso em nosso sistema.</p>

                <div className="booking-summary-box">
                    <div className="summary-item">
                        <span className="summary-label">Barbeiro</span>
                        <span className="summary-value">{bookingDetails.barber}</span>
                    </div>
                    <div className="summary-item">
                        <span className="summary-label">Serviços</span>
                        <span className="summary-value">{bookingDetails.service}</span>
                    </div>
                    <div className="summary-row">
                        <div className="summary-item">
                            <span className="summary-label">Data</span>
                            <span className="summary-value">{bookingDetails.date ? bookingDetails.date.split('-').reverse().join('/') : ''}</span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Horário</span>
                            <span className="summary-value">{bookingDetails.time}</span>
                        </div>
                    </div>
                    <div className="summary-item price-item">
                        <span className="summary-label">Valor Total Estimado</span>
                        <span className="summary-value price-value">{bookingDetails.price}</span>
                    </div>
                </div>

                <div className="success-actions">
                    <button className="confirm-whatsapp-btn" onClick={onBackToHome}>
                        Entendido, Voltar ao Início
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SucessoAgendamento;
